import { render, staticRenderFns } from "./ExportLivret.vue?vue&type=template&id=36f471b8&scoped=true"
import script from "./ExportLivret.vue?vue&type=script&lang=js"
export * from "./ExportLivret.vue?vue&type=script&lang=js"
import style0 from "./ExportLivret.vue?vue&type=style&index=0&id=36f471b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f471b8",
  null
  
)

export default component.exports